module.exports = __webpack_public_path__ + "img/volume_off.544a56a8.svg";